import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center font-heading">热度榜单</h2>
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
            {rankingData.map((item, i) => (
              <div
                key={i}
                className={`flex items-center gap-4 p-4 md:p-5 ${
                  i < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
                } hover:bg-background-200/40 cursor-pointer transition-colors group`}
              >
                <div className={`flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center font-bold text-sm font-heading ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded whitespace-nowrap">{item.category}</span>
                    {item.trend === 'up' && <i className="ri-arrow-up-line text-xs text-accent-500"></i>}
                    {item.trend === 'down' && <i className="ri-arrow-down-line text-xs text-foreground-400"></i>}
                    {item.trend === 'stable' && <i className="ri-subtract-line text-xs text-secondary-500"></i>}
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">{item.title}</h3>
                </div>
                <div className="flex-shrink-0 text-right">
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.heat}</div>
                  <div className={`text-xs whitespace-nowrap ${
                    item.change.startsWith('+') ? 'text-accent-500' : 'text-foreground-400'
                  }`}>{item.change}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}